import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  .ant-form-item {
    margin: 0;
  }
`;

export const StyledInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
